import { buttonContainer, image, message, zeroState } from '../styles/legacy';
import { buttonContainer as buttonContainerCitrus2022, image as imageCitrus2022, message as messageCitrus2022, zeroState as zeroStateCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var ZeroState = citrusStyled.div('zeroState', { legacy: zeroState, citrus2022: zeroStateCitrus2022 });
export var ZeroStateImage = citrusStyled.img('image', { legacy: image, citrus2022: imageCitrus2022 });
export var ZeroStateMessage = citrusStyled.div('message', { legacy: message, citrus2022: messageCitrus2022 });
export var ZeroStateButtonContainer = citrusStyled.div('buttonContainer', {
    legacy: buttonContainer,
    citrus2022: buttonContainerCitrus2022,
});
export var Styled = {
    ZeroState: ZeroState,
    ZeroStateImage: ZeroStateImage,
    ZeroStateMessage: ZeroStateMessage,
    ZeroStateButtonContainer: ZeroStateButtonContainer,
};
